// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col>.labeled-select[data-v-570a6d29]:not(.taggable){height:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
